"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montesilvano": {
    "5f62c07c": [{
      "hkey": "39c6da4e",
      "slug": "montesilvano-colle-via-de-gasperi",
      "name": "Montesilvano Colle-Via De Gasperi",
      "primary": true,
      "skipSearch": false
    }],
    "montesilvano-colli": [{
      "hkey": "39c6da4e",
      "slug": "montesilvano-colle-via-de-gasperi",
      "name": "Montesilvano Colle-Via De Gasperi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8a62d2bf": [{
      "hkey": "36ab2ab2",
      "slug": "montesilvano-spiagga-santa-filomena-villa-verrocchio",
      "name": "Montesilvano Spiagga-Santa Filomena-Villa Verrocchio",
      "primary": true,
      "skipSearch": false
    }],
    "montesilvano-spiaggia": [{
      "hkey": "36ab2ab2",
      "slug": "montesilvano-spiagga-santa-filomena-villa-verrocchio",
      "name": "Montesilvano Spiagga-Santa Filomena-Villa Verrocchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;